import { render, staticRenderFns } from "./Reporting.vue?vue&type=template&id=ef71a690&scoped=true&"
import script from "./Reporting.vue?vue&type=script&lang=js&"
export * from "./Reporting.vue?vue&type=script&lang=js&"
import style0 from "./Reporting.vue?vue&type=style&index=0&id=ef71a690&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef71a690",
  null
  
)

export default component.exports